import { Link, useLocation } from 'react-router-dom'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth } from '@/hooks/useAuth'

const getMenuItems = (t: any) => [
  // === 第一组：核心工作区 ===
  {
    name: 'Home',
    displayName: t('menu.home'),
    href: '/',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
      </svg>
    )
  },
  {
    name: 'Projects',
    displayName: t('menu.projects'),
    href: '/projects',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z" />
      </svg>
    )
  },
  {
    name: 'Products',
    displayName: t('menu.products'),
    href: '/products',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
      </svg>
    ),
    subItems: [
      { name: 'Pipeline Studio', displayName: t('subMenu.pipelineStudio'), href: '/products/pipeline-studio' },
      { name: 'Auto Monitor', displayName: t('subMenu.autoMonitor'), href: 'http://demo.eginnovations.com/', external: true }
    ]
  },

  // === 分隔线 1 ===
  {
    name: 'Divider1',
    isDivider: true
  },

  // === 第二组：管理与许可 ===
  {
    name: 'Plans',
    displayName: t('menu.plans'),
    href: '/plans',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z" />
      </svg>
    )
  },
  {
    name: 'Platform Users',
    displayName: t('menu.platformUsers'),
    href: '/platform-users',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
      </svg>
    ),
    requireOwner: true
  },
  {
    name: 'User Requests',
    displayName: t('menu.userRequests'),
    href: '/user-requests',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
      </svg>
    ),
    requireOwnerOrAdmin: true
  },

  // === 分隔线 2 ===
  {
    name: 'Divider2',
    isDivider: true
  },

  // === 第三组：个人设置与支持 ===
  {
    name: 'Settings',
    displayName: t('menu.settings'),
    href: '/settings',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
    subItems: [
      { name: 'Language', displayName: t('subMenu.language'), href: '/settings/language' },
      { name: 'Profile', displayName: t('subMenu.profile'), href: '/settings/profile' },
      { name: 'Password', displayName: t('subMenu.password'), href: '/settings/password', requireLocalUser: true },
    ]
  },
  {
    name: 'Help',
    displayName: t('menu.help'),
    href: 'https://docs.google.com/document/d/1GY3_gTNkjoPS3XBrCWl10c4uATxiOupCvAeMSVVsfJY/edit?tab=t.xin9hbg2jw6b',
    external: true,
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    )
  }
]

interface SidebarProps {
  collapsed: boolean
}

export default function Sidebar({ collapsed }: SidebarProps) {
  const location = useLocation()
  const { t } = useTranslation('sidebar')
  const { user } = useAuth()
  const [expandedItems, setExpandedItems] = useState<string[]>(['Products', 'Data', 'Settings'])
  const menuItems = getMenuItems(t)

  const isOwner = user?.platform_role === 'owner' || user?.platform_role === 'admin' || user?.platform_role === 'security' || user?.platform_role === 'auditor'
  const isOwnerOrAdmin = user?.platform_role === 'owner' || user?.platform_role === 'admin'

  const toggleExpanded = (itemName: string) => {
    setExpandedItems(prev =>
      prev.includes(itemName)
        ? prev.filter(name => name !== itemName)
        : [...prev, itemName]
    )
  }

  const isItemActive = (item: any) => {
    // Check if current path matches the item's main href
    if (location.pathname === item.href) {
      return true
    }
    // Check if any sub-item matches (exact match or starts with sub-item href)
    if (item.subItems) {
      return item.subItems.some((subItem: any) => {
        if (location.pathname === subItem.href) {
          return true
        }
        // For pipeline-studio detail pages: /products/pipeline-studio/:namespace/:name
        // Also match if path starts with the sub-item href followed by /
        if (location.pathname.startsWith(subItem.href + '/')) {
          return true
        }
        return false
      })
    }
    return false
  }

  const isSubItemActive = (href: string) => {
    // Exact match
    if (location.pathname === href) {
      return true
    }
    // For pipeline-studio detail pages: /products/pipeline-studio/:namespace/:name
    // Also match if path starts with the href followed by /
    if (location.pathname.startsWith(href + '/')) {
      return true
    }
    return false
  }

  return (
    <aside
      className={`bg-white/90 backdrop-blur-xl border-r border-gray-200/50 transition-all duration-300 ease-in-out flex flex-col ${
        collapsed ? 'w-16' : 'w-56'
      }`}
    >
      {/* Main Menu */}
      <nav className="flex-1 p-3 space-y-1 overflow-y-auto">{/* Changed from p-2 to p-3 */}
        {menuItems.map((item) => {
          // Render divider
          if (item.isDivider) {
            return (
              <div key={item.name} className={`${collapsed ? 'my-2' : 'my-3'}`}>
                <div className="h-px bg-gray-300" />
              </div>
            )
          }

          return (
          <div key={item.name}>
            {item.external ? (
              <a
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                className={`flex items-center ${
                  collapsed ? 'justify-center px-2' : 'justify-between px-3'
                } py-3 rounded-lg transition-all duration-200 group ${
                  isItemActive(item)
                    ? 'bg-primary/10 text-primary shadow-sm'
                    : 'text-gray-700 hover:bg-gray-100/50 hover:text-primary'
                }`}
                title={collapsed ? item.displayName : ''}
              >
                <div className="flex items-center space-x-3">
                  <div className={`shrink-0 ${isItemActive(item) ? 'text-primary' : 'text-gray-600 group-hover:text-primary'}`}>
                    {item.icon}
                  </div>
                  {!collapsed && (
                    <span className="font-medium text-sm truncate">{item.displayName}</span>
                  )}
                </div>
              </a>
            ) : item.subItems ? (
              <>
                {collapsed ? (
                  // When collapsed, render as simple clickable link
                  <Link
                    to={item.href}
                    className={`flex items-center justify-center px-2 py-3 rounded-lg transition-all duration-200 group ${
                      isItemActive(item)
                        ? 'bg-primary/10 text-primary shadow-sm'
                        : 'text-gray-700 hover:bg-gray-100/50 hover:text-primary'
                    }`}
                    title={item.displayName}
                  >
                    <div className={`shrink-0 ${isItemActive(item) ? 'text-primary' : 'text-gray-600 group-hover:text-primary'}`}>
                      {item.icon}
                    </div>
                  </Link>
                ) : (
                  // When expanded, render with separate link and expand button
                  <div className={`flex items-center rounded-lg ${
                    isItemActive(item)
                      ? 'bg-primary/10 text-primary shadow-sm'
                      : 'text-gray-700 hover:bg-gray-100/50 hover:text-primary'
                  } transition-all duration-200 group`}>
                    <Link
                      to={item.href}
                      className="flex-1 flex items-center px-3 py-3"
                    >
                      <div className="flex items-center space-x-3 min-w-0">
                        <div className={`shrink-0 ${isItemActive(item) ? 'text-primary' : 'text-gray-600 group-hover:text-primary'}`}>
                          {item.icon}
                        </div>
                        <span className="font-medium text-sm truncate">{item.displayName}</span>
                      </div>
                    </Link>
                    <button
                      onClick={(e) => {
                        e.stopPropagation()
                        toggleExpanded(item.name)
                      }}
                      className="px-3 py-3 hover:bg-primary/5 rounded-r-lg transition-colors"
                    >
                      <svg
                        className={`w-4 h-4 shrink-0 transition-transform duration-200 ${
                          expandedItems.includes(item.name) ? 'rotate-180' : ''
                        }`}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    </button>
                  </div>
                )}
                {!collapsed && expandedItems.includes(item.name) && (
                  <div className="ml-6 mt-1 space-y-0.5 border-l-2 border-gray-200/50 pl-3">
                    {item.subItems
                      .filter((subItem: any) => {
                        if (subItem.requireOwner && !isOwner) return false
                        if (subItem.requireLocalUser && user?.type !== 'local') return false
                        return true
                      })
                      .map((subItem: any) =>
                      subItem.external ? (
                        <a
                          key={subItem.name}
                          href={subItem.href}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="block px-3 py-2 rounded-lg text-sm transition-all duration-200 text-gray-600 hover:bg-gray-100/50 hover:text-primary truncate"
                        >
                          {subItem.displayName}
                        </a>
                      ) : (
                        <Link
                          key={subItem.name}
                          to={subItem.href}
                          className={`block px-3 py-2 rounded-lg text-sm transition-all duration-200 truncate ${
                            isSubItemActive(subItem.href)
                              ? 'bg-primary/10 text-primary font-medium'
                              : 'text-gray-600 hover:bg-gray-100/50 hover:text-primary'
                          }`}
                        >
                          {subItem.displayName}
                        </Link>
                      )
                    )}
                  </div>
                )}
              </>
            ) : (
              (item.requireOwner && !isOwner) || (item.requireOwnerOrAdmin && !isOwnerOrAdmin) ? null : (
                <Link
                  to={item.href || ''}
                  className={`flex items-center ${
                    collapsed ? 'justify-center px-2' : 'justify-between px-3'
                  } py-3 rounded-lg transition-all duration-200 group ${
                    isItemActive(item)
                      ? 'bg-primary/10 text-primary shadow-sm'
                      : 'text-gray-700 hover:bg-gray-100/50 hover:text-primary'
                  }`}
                  title={collapsed ? item.displayName : ''}
                >
                  <div className="flex items-center space-x-3 min-w-0">
                    <div className={`shrink-0 ${isItemActive(item) ? 'text-primary' : 'text-gray-600 group-hover:text-primary'}`}>
                      {item.icon}
                    </div>
                    {!collapsed && (
                      <span className="font-medium text-sm truncate">{item.displayName}</span>
                    )}
                  </div>
                </Link>
              )
            )}
          </div>
          )
        })}
      </nav>
    </aside>
  )
}
